<template>
  <div class="qqbj">
	<div class="qqbjBox">
		<div class="qqbjBoxFor" v-for="(item,index) in qqbj" :key="index">
			<div class="qqbjBoxForImg">
				<img :src="item.cover" />
			</div>
			<div class="qqbjBoxForWz">
				<div class="qqbjBoxForWzName">
					{{item.city}}
				</div>
				<div class="qqbjBoxForWzCen">
					<div class="qqbjBoxForWzCenFor" >
						<!-- v-for="(itema,indexa) in item.list" :key="indexa" -->
						{{item.rd_center}}
						<p style="margin-bottom: 6px;"></p>
						{{item.production_base}}
					</div>
				</div>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
	props:{
		qqbj:{
			typeof:Array,
			default:[]
		}
	},
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.qqbj{
	// height: 100vh;
	width: 100%;
	padding: 125px 0;
	.qqbjBox{
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-wrap: wrap;
		.qqbjBoxFor:hover{
			.qqbjBoxForImg{
				img{
					// transform: scale(1.1);
				}
			}
		}
		.qqbjBoxFor{
			width: 400px;
			.qqbjBoxForImg{
				width: 375px;
				height: 260px;
				overflow: hidden;
				img{
					width: 100%;
					height: 100%;
					transition: all 0.3s ease-in-out;
				}
			}
			.qqbjBoxForWz{
				width: 375px;
				.qqbjBoxForWzName{
					font-size:20px;
					font-family: Source Han Sans CN;
					font-weight: 300;
					color: #000000;
					margin: 20px 0;
				}
				.qqbjBoxForWzCen{
					height:100px;
					overflow-y: auto;
					margin-bottom: 20px;
					.qqbjBoxForWzCenFor:not(:last-child){
						margin-bottom: 20px;
					}
					.qqbjBoxForWzCenFor{
						font-size: 16px;
						font-family: Source Han Sans CN;
						font-weight: 300;
						color: #000000;
					}
				}
			}
		}
	}
}
@media screen and (max-width:1200px) {
		.qqbj{
			padding:0 0 30px  !important;
			overflow: hidden;
		}
		.qqbjBox{
			width: 100% !important;
			
		}
		.qqbjBoxFor{
			width: calc(100% - 60px) !important;
			margin: 0 auto !important;
			.qqbjBoxForImg{
				width: 100% !important;
			}
		}
	}
</style>
